var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
export const get = (triggerEvent) => {
    return axios.get('/cart.js').then((res) => {
        return processResponse(res.data);
    });
};
const cartUpdated = (items, count) => {
    window.dispatchEvent(new CustomEvent('hg-cart-updated', {
        detail: {
            items,
            count,
        },
    }));
};
export const add = (items) => {
    if (items.length === 0) {
        return;
    }
    return axios
        .post('/cart/add.js', {
        items,
    })
        .then((res) => __awaiter(void 0, void 0, void 0, function* () {
        const newCart = yield get();
        fetch(window.Shopify.routes.root + '?sections=cart-drawer')
            .then((res) => res.json())
            .then((res) => {
            const cartDrawer = document.querySelector('#cart-drawer');
            const html = Object.values(res);
            const updatedDrawerContent = new DOMParser().parseFromString(html, 'text/html');
            cartDrawer.replaceChildren(document
                .createRange()
                .createContextualFragment(updatedDrawerContent.querySelector('.cart-drawer').innerHTML));
        })
            .then(() => document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
                cart: newCart,
            },
        })));
        return newCart;
    }));
};
export const update = (updates) => {
    if (Object.keys(updates).length === 0) {
        return;
    }
    return axios
        .post(window.Shopify.routes.root + 'cart/update.js', {
        updates: updates,
    })
        .then((res) => {
        return processResponse(res.data);
    });
};
export const change = (item) => {
    return axios.post('/cart/change.js', item).then((res) => {
        return processResponse(res.data);
    });
};
export const deleteItems = (deletes) => {
    if (Object.keys(deletes).length === 0) {
        return;
    }
    const updates = {};
    deletes.forEach((id) => {
        updates[id] = 0;
    });
    return update(updates);
};
export const empty = () => {
    return axios.post('/cart/clear.js').then((res) => {
        return processResponse(res.data);
    });
};
const processResponse = (cartData) => {
    const lineItems = cartData.items;
    const count = cartData.item_count;
    cartUpdated(lineItems, count);
    return cartData;
};
export default {
    get,
    add,
    update,
    change,
    delete: deleteItems,
    empty,
};
